<p-toolbar class="flex justify-content-end" styleClass="pr-0 pl-0 pt-0 mt-3">
    <div class="grid">
        <div class="mr-2" *ngIf="addButtonShow == null || addButtonShow">
            <button
                id="{{ inputId + '_add' }}"
                [disabled]="addButtonDisabled != null ? addButtonDisabled : false"
                pButton
                label="{{ hrKey.common.buttonAdd | translate }}"
                (click)="openAddFormEvent()"
            >
                <i class="material-icons">add</i>
            </button>
        </div>
        <div class="mr-2" *ngIf="blockButtonShow">
            <button
                id="{{ inputId + '_block' }}"
                class="p-button-outlined"
                [disabled]="blockButtonDisabled != null ? blockButtonDisabled : false"
                pButton
                label="{{ hrKey.common.buttonBlock | translate }}"
                (click)="block()"
            >
                <i class="material-icons">block</i>
            </button>
        </div>
        <div class="mr-2" *ngIf="copyButtonShow == null || copyButtonShow">
            <button id="{{ inputId + '_copy' }}" class="p-button-outlined" [disabled]="copyButtonDisabled" pButton label="{{ hrKey.common.buttonCopy | translate }}" (click)="openCopyFormEvent()">
                <i class="material-icons">content_copy</i>
            </button>
        </div>
        <div class="mr-2" *ngIf="editButtonShow == null || editButtonShow">
            <button
                id="{{ inputId + '_edit' }}"
                class="p-button-outlined"
                [disabled]="editButtonDisabled"
                pButton
                label="{{ editButtonLabel || (hrKey.common.buttonEdit | translate) }}"
                (click)="openEditFormEvent()"
            >
                <i class="material-icons">edit</i>
            </button>
        </div>
        <div class="mr-2" *ngIf="viewButtonShow == null ? false: viewButtonShow">
            <button
                id="{{ inputId + '_view' }}"
                class="p-button-outlined"
                [disabled]="viewButtonDisabled"
                pButton
                label="{{ viewButtonLabel || (hrKey.common.buttonView | translate) }}"
                (click)="openViewFormEvent()"
            >
                <i class="material-icons">visibility</i>
            </button>
        </div>
        <div class="mr-2" *ngIf="removeButtonShow == null || removeButtonShow">
            <button
                id="{{ inputId + '_delete' }}"
                class="p-button-outlined"
                [disabled]="removeButtonDisabled"
                pButton
                label="{{ hrKey.common.buttonDelete | translate }}"
                (click)="openRemoveFormEvent()"
            >
                <i class="material-icons">delete_outline</i>
            </button>
        </div>
        <ng-content></ng-content>
    </div>
</p-toolbar>
